export const highlightText = (text, highlight, key) => {
    let highlightList = [];

    if (Array.isArray(highlight)) {
        highlightList = key ? highlight.map(item => item[key]) : highlight;
    } else if (typeof highlight === "string") {
        highlightList = [highlight];
    }

    const newResultText = highlightList.reduce((result, highlightItem) => {
        const smallSearchInput = highlightItem;
        return result.replace(new RegExp(smallSearchInput, "gi"), match => `<span>${match}</span>`);
    }, text);

    return newResultText;
};
